<template>
  <el-tooltip
    :content="content"
    :placement="placement"
    class="Tooltip"
    effect="dark"
  >
    <i class="fas fa-question-circle" />
  </el-tooltip>
</template>

<script>
import Vue from 'vue';
import { Tooltip } from 'element-ui';

Vue.use(Tooltip);

export default {
  name: 'Tooltip',
  props: {
    content: {
      type: String,
      default: 'lorem ipsum',
    },
    placement: {
      type: String,
      default: 'top',
    },
  },
};
</script>

<style scoped lang="scss">
.Tooltip {
  font-size: 14px;
  color: $color--primary;
}
</style>
